import { isValidZipCode } from "@/utils/validators/isValidZipCode";

export const addressFormValues = {
  zipCode: "",
  street: "",
  number: "",
  neighborhood: "",
  city: "",
  state: "",
  complement: "",
};

export function addressFormValidator(value: typeof addressFormValues) {
  return {
    zipCode: !isValidZipCode(value.zipCode) && "Digite um CEP",
    street: !value.street && "Digite uma rua",
    number: !value.number && "Digite um número",
    neighborhood: !value.neighborhood && "Digite um bairro",
    city: !value.city && "Digite uma cidade",
    state: !value.state && "Digite um estado",
  };
}
